import { motion } from "framer-motion";
import { Play, Zap, Shield, Brain, ExternalLink, Sparkles } from "lucide-react";
import { useApi } from "../../services/api";


const Hero = () => {
  const { isAuthenticated } = useApi();
  const showSmartLink = isAuthenticated;

  console.log('🔍 Hero - isAuthenticated:', isAuthenticated);
  console.log('🔍 Hero - showSmartLink:', showSmartLink);

  return (
    <section className="section-padding pt-32 pb-20 bg-gradient-to-br from-primary-50 via-white to-accent-50">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="inline-flex items-center space-x-2 bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-medium"
            >
              <Zap className="w-4 h-4" />
              <span>
                Sua Solução Customizada de IA para Análise Preditiva de Dados e
                Documentos
              </span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-center text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight"
            >
              🚀 A IA que entende seus dados.{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-500 to-accent-500">
                Você quem toma a melhor DECISÃO!
              </span>{" "}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="text-center text-xl text-gray-600 leading-relaxed"
            >
              Automatize a análise de documentos com IA avançada.
              <p>
                Faça análise semântica de textos com identificação de padrões,
                anomalias e insights.
              </p>
            </motion.p>

            {/* Features */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="flex flex-wrap gap-4"
            >
              <div className="flex items-center space-x-2 text-gray-600">
                <Shield className="w-5 h-5 text-primary-500" />
                <span>Segurança Enterprise</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-600">
                <Brain className="w-5 h-5 text-accent-500" />
                <span>IA de Última Geração</span>
              </div>
            </motion.div>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1 }}
              className="flex flex-col sm:flex-row gap-4"
            >
              {/* <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="btn-primary flex items-center space-x-2"
              >
                <span>Teste grátis</span>
                <ArrowRight className="w-5 h-5" />
              </motion.button> */}

              <motion.a
                href="#planos"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="btn-outline flex items-center space-x-2"
              >
                <Play className="w-5 h-5" />
                <span>Ver planos</span>
              </motion.a>
            </motion.div>
          </motion.div>

          {/* Right Content - Mockup */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="relative"
          >
            {/* Mockup Container */}
            <div className="relative bg-white rounded-2xl shadow-2xl p-8 transform rotate-3 hover:rotate-0 transition-transform duration-500">
              {/* Mockup Header */}
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex space-x-2">
                  <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                </div>
                <div className="flex-1 flex items-center justify-center space-x-2">
                  <span className="text-sm font-medium text-gray-600">
                    TANDER SMART - Análise de Documentos
                  </span>
                  
                  {/* Debug info */}
                 

                  {showSmartLink && (
                    <motion.a
                      href="https://tander-smart-app.web.app/chat"
                      target="_blank"
                      rel="noopener noreferrer"
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      className="group relative inline-flex items-center justify-center"
                      title="Acessar Tander Smart"
                    >
                      <motion.div
                        animate={{ 
                          boxShadow: [
                            '0 0 0 0 rgba(59, 130, 246, 0.4)',
                            '0 0 0 6px rgba(59, 130, 246, 0)',
                          ]
                        }}
                        transition={{ duration: 1.5, repeat: Infinity }}
                        className="absolute inset-0 rounded-full"
                      />
                      <div className="relative bg-gradient-to-r from-primary-500 to-accent-500 text-white p-1.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-200">
                        <ExternalLink className="w-3.5 h-3.5" />
                      </div>
                      <Sparkles className="absolute -top-1 -right-1 w-3 h-3 text-yellow-400 animate-pulse" />
                    </motion.a>
                  )}
                  
                  {!showSmartLink && (
                    <span className="text-xs text-red-500">
                      
                    </span>
                  )}
                </div>
              </div>

              {/* Mockup Content */}
              <div className="space-y-4">
                <div className="bg-gradient-to-r from-primary-100 to-accent-100 p-4 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-primary-500 rounded-lg flex items-center justify-center">
                      <Zap className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <div className="h-3 bg-primary-300 rounded w-32"></div>
                      <div className="h-2 bg-primary-200 rounded w-24 mt-2"></div>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="bg-gray-100 p-3 rounded-lg">
                    <div className="h-2 bg-gray-300 rounded w-full mb-2"></div>
                    <div className="h-2 bg-gray-300 rounded w-3/4"></div>
                  </div>
                  <div className="bg-gray-100 p-3 rounded-lg">
                    <div className="h-2 bg-gray-300 rounded w-full mb-2"></div>
                    <div className="h-2 bg-gray-300 rounded w-1/2"></div>
                  </div>
                </div>

                <div className="bg-accent-50 p-4 rounded-lg border-l-4 border-accent-500">
                  <div className="flex items-center space-x-2">
                    <Brain className="w-5 h-5 text-accent-600" />
                    <span className="text-sm font-medium text-accent-800">
                      Análise concluída em 2.3s
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Elements */}
            <motion.div
              animate={{ y: [-10, 10, -10] }}
              transition={{ duration: 3, repeat: Infinity }}
              className="absolute -top-4 -right-4 bg-accent-500 text-white p-3 rounded-full shadow-lg"
            >
              <Zap className="w-6 h-6" />
            </motion.div>

            <motion.div
              animate={{ y: [10, -10, 10] }}
              transition={{ duration: 4, repeat: Infinity }}
              className="absolute -bottom-4 -left-4 bg-primary-500 text-white p-3 rounded-full shadow-lg"
            >
              <Shield className="w-6 h-6" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
